import { CalendarCheck } from "lucide-react";
import { CHRISTMAS_CUTOFFS } from "../lib/christmas";

export const ChristmasCutoffs = () => {
  const now = Date.now();
  return (
    <div data-testid="christmas-cutoffs" className="mt-8 max-w-2xl mx-auto">
      <p className="font-mono-x text-xs uppercase tracking-[0.2em] font-bold text-white/90 flex items-center justify-center gap-2">
        <CalendarCheck className="w-4 h-4" /> Last day to order for Christmas
      </p>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3">
        {CHRISTMAS_CUTOFFS.map((c) => {
          const closed = now > c.until;
          return (
            <div key={c.key} data-testid={`cutoff-${c.key}`}
              className={`rounded-2xl border-2 border-[var(--ink)] px-4 py-3 text-left sm:text-center ${closed ? "bg-white/20 text-white" : "bg-[#1e7a46] text-white"}`}>
              <span className="block text-sm font-semibold">{c.label}</span>
              <span className="block font-display font-extrabold text-xl">{closed ? "Closed" : c.day}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
